import { useCallback, useEffect, useState } from "react";
import { getQuarter } from "../../services/customerTouchPoint";

const useQuarter = () => {
    const [data, setData] = useState([]);

    const fetchData = useCallback(async () => {
        const res = await getQuarter();

        if (res.data.code === "0000") {
            setData(res.data.objectValue);
        }
    }, [setData]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return [data];
};

export default useQuarter;
